<template>
   <div :class="darkMode ? 'dark' : ''">

      <div id="maincontainer" class="lg:px-[5%] xl:px-[10%]  !font-sans bg-white dark:bg-[#171a35]">
         <div class=" items-center !content-center !justify-center !mx-auto !px-auto">
            <!-- BARRA DEL TITOLO -->
            <div v-if="!$vuetify.breakpoint.smAndDown" no-gutters class="hidden sm:block mt-4 justify-between bg-csenBlue-900 dark:!bg-csenBlue-800 text-white">
               <div class="block sm:flex px-6 py-5 sm:text-xl font-medium">
                  <div class="sm:w-1/2 inline-flex col-span-1 my-auto mr-6 font-semibold">
                     <div class="my-auto">
                        <h2>Scheda di:</h2>
                     </div>
                     <div class="ml-4 my-auto">
                        <div class="py-2 rounded-full px-3 !text-white inline-flex !bg-csenBlue-950 dark:!bg-csenBlue-600">
                           <UserIcon class="mr-2 my-auto !text-csenBlue-200" />
                           <span class="text-sm my-auto !font-medium mr-1">{{ nomeCognomeTecnicoVisualizzato }}</span>
                        </div>
                     </div>
                  </div>
                  <div class="sm:w-1/2 sm:flex sm:justify-end items-center sm:col-span-1 my-auto text-sm gap-2">
                     <!-- FAQ -->
                     <div id="faq-btn" @click="redirectToFAQ()" title="Vai alle F.A.Q."
                        class="inline-flex group px-4 py-2 rounded-full bg-violet-600 dark:bg-violet-500 hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 transition cursor-pointer">
                        <ChatIcon></ChatIcon>
                        <span class="my-auto text-xs ml-2 text-white group-hover:text-white">Hai dei dubbi o problemi?</span>
                     </div>
                     <!-- Guida -->
                     <!-- v-bind="attrs" v-on="on" -->
                     <div id="guida-btn" icon @click="$refs.pannelloTecniciRef.avviaTour('tecnico')"
                        class="tour-step-30 inline-flex group px-4 py-2 rounded-full bg-csenBlue-700 hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 transition cursor-pointer">
                        <v-icon color="white" class="my-auto mr-2" size="21">mdi-help-circle-outline</v-icon>
                        <span class="my-auto text-xs text-csenBlue-200 group-hover:text-white">Come funziona la mia scheda?</span>
                     </div>
                     <!-- Chip -->
                     <!-- Toggle Dark Mode -->
                     <div id="dark-mode" class="text-white my-auto">
                        <div
                           :title="darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
                           @click="toggleDarkMode()"
                           class="bg-csenBlue-700 dark:bg-csenBlue-700 text-csenBlue-100 inline-flex justify-center content-center px-auto cursor-pointer rounded-full hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 hover:text-white transition w-9 h-9"
                           >
                           <SunIcon v-if="darkMode" class="my-auto" />
                           <MoonIcon v-else class="my-auto" />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- BARRA DEL TITOLO DA MOBILE -->
            <div v-else class="sm:hidden">
               <div class="bg-csenBlue-900 dark:!bg-csenBlue-800 text-white">

                  <div class="flex">
                     <div class="py-6 pl-6 text-white text-base font-semibold"> Scheda di: 
                        <span class="text-csenBlue-200 text-base">{{ nomeCognomeTecnicoVisualizzato }}</span>
                     </div>
                     <!-- Toggle Dark Mode -->
                     <div class="flex justify-end pr-6 mx-auto text-white my-auto">
                           <div
                              id="dark-mode"
                              :title="darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'"
                              @click="toggleDarkMode()"
                              class="bg-csenBlue-700 dark:bg-csenBlue-700 text-csenBlue-100 inline-flex justify-center content-center px-auto cursor-pointer rounded-full hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 hover:text-white transition w-9 h-9"
                              >
                              <SunIcon v-if="darkMode" class="my-auto" />
                              <MoonIcon v-else class="my-auto" />
                           </div>
                        </div>
                  </div>
                  <div class="bg-csenBlue-900 dark:bg-csenBlue-800 inline-flex w-full px-2 pb-4 gap-2 overflow-x-auto whitespace-nowrap">
                     
                     <!-- FAQ -->
                     <div id="faq-btn" @click="redirectToFAQ()" title="Vai alle F.A.Q."
                        class="flex justify-center group ml-2 px-4 rounded-md py-2 w-full bg-violet-600 dark:bg-violet-500 hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 transition cursor-pointer">
                        <ChatIcon class="my-auto"></ChatIcon>
                        <div class="my-auto text-xs ml-2 leading-3 text-white group-hover:text-white">Hai dei dubbi o dei problemi?</div> 
                     </div>
                     <!-- Guida -->
                     <div id="guida-btn" icon @click="$refs.pannelloTecniciRef.avviaTour('tecnico')"
                        class="tour-step-30 rounded-md flex px-4 justify-center group py-2 bg-csenBlue-700 hover:bg-csenOrange-500 dark:hover:bg-csenOrange-500 transition cursor-pointer">
                        <v-icon color="white" class="my-auto mr-2" size="21">mdi-help-circle-outline</v-icon>
                        <span class="my-auto text-xs text-csenBlue-200 group-hover:text-white">Come funziona la mia scheda?</span>
                     </div>
                  </div>
                  
               </div>
            </div>


            <!-- COMPONENTE PANNELLO TECNICI-->
            <PannelloTecniciComponente ref="pannelloTecniciRef" :tecnico-id="tecnicoId" @tecnico-modificato="isTecnicoModificato = true" @nome-cognome-tecnico-set="nomeCognomeTecnicoSet" class=" !flex !items-center !content-center !justify-center !mx-auto !px-auto"></PannelloTecniciComponente>
            <!-- AZIONI  -->
            <div 
               class="flex fixed justify-end items-end bottom-[160px] lg:bottom-8 right-4 md:right-8 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition" 
               @click="scrollToTop"
            >
               <div><ChevronUpIcon></ChevronUpIcon></div>
            </div>

            <v-row no-gutters class="p-4 justify-between bg-gray-300 dark:bg-csenBlue-800 sticky bottom-0 z-50">
               <!-- <v-col cols="3">
                  <v-btn class="!bg-white !text-sky-600" @click="vaiATecnici">
                     <OutsideLink></OutsideLink> 
                     <span class="ml-2">Torna all'elenco tecnici</span>
                  </v-btn>
                  </v-col> -->
               <v-col class="text-right">
                  <!-- cols="3" -->
                  <v-btn class="!bg-gray-400/30 dark:!bg-transparent sm:!flex-row-reverse !tracking-wider w-full sm:!w-auto my-1 !py-6 !px-4" text @click="vaiATecniciConferma()">
                     <LeftArrowIcon class="!text-gray-500 dark:!text-csenBlue-400 mr-2"></LeftArrowIcon>
                     Annulla e torna all'elenco
                  </v-btn>
                  <!-- VECCHIO <v-btn :disabled="!isTecnicoModificato" class="!tracking-normal"  @click="validaTecnico()">Salva e torna all'elenco</v-btn> -->
                  <v-btn :disabled="!isTecnicoModificato" 
                     :class="(isTecnicoModificato ? '!bg-csenGreen-500 !text-white ' : '') + '!tracking-wide !py-6 my-1 !px-5 w-full sm:!w-auto '" 
                     text
                     @click="validaTecnico()"
                     id="salva-modifiche"
                     >
                     Salva e torna all'elenco
                  </v-btn>
               </v-col>
            </v-row>
         </div>
         <!-- FOOTER -->
         <div>
            <FooterComponent></FooterComponent>
         </div>
         <!-- FINE FOOTER -->
      </div>
   </div>
</template>




<script>
    /* icone custom */
    import ContattiIcon from '../components//icons/ContattiIcon.vue';
    import VerifiedIcon from '../components//icons/VerifiedIcon.vue';
    import AddressIcon from '../components/icons/AddressIcon.vue';
    import UserIcon from '../components/icons/UserIcon.vue';
    import GraduationIcon from '../components/icons/GraduationIcon.vue';
    import PhoneIcon from '../components/icons/PhoneIcon.vue';
    import InfoIcon from '../components/icons/InfoIcon.vue';
    import UserSearchIcon from '../components/icons/UserSearchIcon.vue';
    import IdCardIcon from '../components/icons/IdCardIcon.vue';
    import OutsideLink from '../components/icons/OutsideLink.vue';
    import LeftArrowIcon from '../components/icons/LeftArrowIcon.vue';
    import PannelloTecniciComponente from '../components/PannelloTecniciComponente.vue';
   import SunIcon from '../components/icons/SunIcon.vue';
   import MoonIcon from '../components/icons/MoonIcon.vue';
   import DesktopIcon from '../components/icons/DesktopIcon.vue';
   import MobileIcon from '../components/icons/MobileIcon.vue'; 
   import ChatIcon from '../components/icons/ChatIcon.vue'; 

    import mixin from '../mixin';
    import store from '../store';
  
    export default {
      components: {
        GraduationIcon, PannelloTecniciComponente, LeftArrowIcon, DesktopIcon, MobileIcon, ChatIcon
      },
      mixins: [mixin],
      data() {
         return {
            tecnicoId: null,

            nomeCognomeTecnicoVisualizzato: null,

				isTecnicoModificato: false,
         };
      },
  
      created() {
            // Prima controllo che il frontEnd abbia capito che sono loggato come tecnico
            store.commit('controllaLogin', ()=>{
               this.tecnicoId = this.$route.params.tecnicoid;

               // Se sono admin rimando alla tabella dei tecnici. Questa schermata è solo per i tecnic
               if(!this.loggedAs || this.loggedAs.ruolo != 'tecnico')
                  this.$router.push('/tecnici');
            });
      },
      methods: {
         ricaricaPagina(){
            location.reload();
         },

         toggleDarkMode() {
            store.commit('toggleDarkMode');
         },

         nomeCognomeTecnicoSet(nomeCognome){
            this.nomeCognomeTecnicoVisualizzato = nomeCognome;
         },

         validaTecnico(){ // Per poi proseguire con l'inserimento/modifica
            if(this.$refs.pannelloTecniciRef.validaTecnico()){

               this.$refs.pannelloTecniciRef.aggiungiModificaTecnico(()=>{
                  store.commit('mostraSnack', {messaggio: 'Modifiche eseguite con successo', tipo: 'success'})
               });
               this.vaiATecnici();
            } else {
               store.commit('mostraSnack', {messaggio: 'Campi obbligatori non compilati, per favore ricontrollare', tipo: 'warning'})
            }
         },

         vaiATecniciConferma(){
            if(this.isTecnicoModificato){
					store.commit('mostraDialogConferma', 
						{
							titolo: 'Esci senza salvare le modifiche',
							testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
							onConferma:()=>{
								this.vaiATecnici();
								store.commit('nascondiDialogConferma');
							}, 
							onAnnulla:()=>{
								store.commit('nascondiDialogConferma');
							}
						}
					)
				} else {
					this.vaiATecnici();
				}
         },
         vaiATecnici() {
            this.$router.push('/tecnici');
         },

      },
   };
   
</script>
<style scoped>
</style>
